// import React, { useState } from "react";
import React, { useState, useEffect } from "react";

import bedrockcareLogo from "../../../assets/EMP_clients/testimonials/bedrockcare-logo.svg";

import bridgestoneLogo from "../../../assets/EMP_clients/testimonials/bridgestone-logo.svg";

import justSaladLogo from "../../../assets/EMP_clients/testimonials/just-salad-logo.svg";

import legacyLogo from "../../../assets/EMP_clients/testimonials/legacy-logo.svg";

import ssSejLogo from "../../../assets/EMP_clients/testimonials/ss-sej-logo.svg";

const testimonials = [
  {
    quote:
      "As part of our commitment to supporting employees, we are always looking for new and innovative ways to enhance our corporate benefits. Through our partnership with DailyPay, we're proud to offer our team members financial flexibility by allowing them to access their earnings at a time most convenient for them.",

    name: "Ana Ledesma",

    role: "Director of HR, Just Salad",

    logo: bedrockcareLogo,
  },

  {
    quote:
      "DailyPay has been a game changer to recruiting, retaining, and rewarding our hard-working team members. We have partnered with DailyPay for over a year and currently 82% of our team is enrolled in DailyPay with 47% actively using the platform—as you can see from our participation rates, this is a true benefit for our employees.",

    name: "Brandon Schneider",

    role: "Owner and CEO, SEJ Services",

    logo:  bridgestoneLogo,
  },

  {
    quote:
      "We rolled out DailyPay to the majority of our hourly employees in 2023. We have received very positive feedback from those using DailyPay. Teammates using DailyPay report an added sense of financial security. Bridgestone has also seen a direct decrease in turnover from the population using DailyPay.",

    name: "Barbara Vetula",

    role: "Bridgestone",

    logo: justSaladLogo,
  },

  {
    quote:
      "DailyPay has been a lifesaver for many of our employees. DailyPay's implementation process was quick and easy. DailyPay is clearly the most rewarding benefit we have been able to bring to our workforce.",

    name: "Angelic Principe",

    role: "SVP of HR, Legacy Healthcare",

    logo: legacyLogo,
  },

  {
    quote:
      "Most working people would agree life doesn't fit neatly into a weekly or bi-weekly timeline of bills and expenses. We owe it to our employees to make accessing their funds as easy as possible wherever possible.",

    name: "Brett Boyer",

    role: "VP Labor Management, The Bedrock Care Group",

    logo: ssSejLogo,
  },
];

export default function TestimonialsSlider() {
  const [activeIndex, setActiveIndex] = useState(0);

  const nextSlide = () => {
    setActiveIndex((prev) =>
      prev === testimonials.length - 1 ? 0 : prev + 1
    );
  };
  useEffect(() => {
  const interval = setInterval(() => {
    setActiveIndex((prev) =>
      prev === testimonials.length - 1 ? 0 : prev + 1
    );
  }, 3000);

  return () => clearInterval(interval);
}, []);

  const prevSlide = () => {
    setActiveIndex((prev) =>
      prev === 0 ? testimonials.length - 1 : prev - 1
    );
  };

  const activeItem = testimonials[activeIndex];

  return (
    <section
      className="
        w-full

        bg-[white]

        py-20
        lg:py-28
      "
    >
      <div
        className="
          max-w-[1400px]
          lg:max-w-[900px]

          mx-auto

          px-6
          sm:px-10
          lg:px-20

          relative
        "
      >
        {/* TOP LINE */}
        <div
          className="
            flex
            items-center
            justify-center

            gap-6
          "
        >
          <div className="flex-1 h-[1px] bg-[#cfcfcf]" />

          <span
            className="
              text-[#ff5a00]

              text-[70px]
              lg:text-[90px]

              leading-none

              font-bold
            "
          >
            “
          </span>

          <div className="flex-1 h-[1px] bg-[#cfcfcf]" />
        </div>

       {/* CONTENT */}
<div
  className="
    mt-8

    max-w-[980px]

    mx-auto

    text-center
  "
>
  <h2
    className="
      text-[#1b0707]

      text-[24px]
      sm:text-[20px]
      lg:text-[22px]

      leading-[1.25]

      font-serif

      max-w-[920px]

      mx-auto
    "
  >
    "{activeItem.quote}"
  </h2>

  <h4
    className="
      mt-8

      text-[#1f2937]

      text-[20px]
      lg:text-[16px]

      font-bold
    "
  >
    {activeItem.name}
  </h4>

  <p
    className="
      mt-2

      text-[#6b7280]

      text-[18px]
      lg:text-[14px]
    "
  >
    {activeItem.role}
  </p>

  <img
    src={activeItem.logo}
    alt="company logo"

    className="
      mx-auto

      mt-6

      h-[45px]
      lg:h-[42px]

      object-contain
    "
  />
</div>
        {/* SIDE BUTTONS */}
       <button
  onClick={prevSlide}
  className="
    hidden
    lg:flex

    absolute

    left-4
    lg:left-0

    top-1/2
    -translate-y-1/2

    w-[55px]
    h-[55px]

    lg:w-[50px]
    lg:h-[50px]

    rounded-full

    bg-[#4b0000]

    text-white

    text-[30px]

    items-center
    justify-center

    shadow-lg
  "
>
  ‹
</button>

<button
  onClick={nextSlide}
  className="
    hidden
    lg:flex

    absolute

    right-4
    lg:right-0

    top-1/2
    -translate-y-1/2

    w-[55px]
    h-[55px]

    lg:w-[50px]
    lg:h-[50px]

    rounded-full

    bg-[#4b0000]

    text-white

    text-[30px]

    items-center
    justify-center

    shadow-lg
  "
>
  ›
</button>

        {/* BOTTOM LINE */}
        <div
          className="
            mt-16

            h-[1px]

            bg-[#cfcfcf]
          "
        />

        {/* DOTS */}
        <div
          className="
            mt-10

            flex
            items-center
            justify-center

            gap-5
          "
        >
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => setActiveIndex(index)}
              className={`
                rounded-full

                transition-all
                duration-300

                ${
                  activeIndex === index
                    ? "bg-[#ff5a00] w-[16px] h-[16px]"
                    : "bg-[#ffb08a] w-[12px] h-[12px]"
                }
              `}
            />
          ))}
        </div>
      </div>
    </section>
  );
}